import { useEffect, useState } from 'react';
import { erkenneHandy, vergissAlteDesktopWahl } from '../utils/mobilModus';

// Mobilansicht an, wenn das Gerät ein Handy ist. Einen Schalter zur
// Desktop-Ansicht gibt es seit v2.5.1 nicht mehr (siehe utils/mobilModus).
export default function useMobilModus() {
  const [istHandy, setIstHandy] = useState(() => erkenneHandy());

  useEffect(() => {
    vergissAlteDesktopWahl();
    const neu = () => setIstHandy(erkenneHandy());
    window.addEventListener('orientationchange', neu);
    return () => window.removeEventListener('orientationchange', neu);
  }, []);

  return { istHandy, aktiv: istHandy };
}
